import { DPad } from "./DPad";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { RoadManager } from "./Roadmanager";
import { AudioManager } from "../../AudioManager";
import { GameVars } from "../../GameVars";

export class GUI extends Phaser.Group {

    private dPad: DPad;
    private jumpButton: Phaser.Image;
    private jumpText: Phaser.Text;

    constructor(game: Phaser.Game) {

        super(game, null, "gui");

        let pauseButton_px = GameConstants.SPONSOR === GameConstants.SPONSOR_FUNO ? GameConstants.GAME_WIDTH - 55 * GameVars.scaleX : 10;

        const pauseButton = new Phaser.Button(this.game, pauseButton_px, 10, "texture_atlas_1", this.onPauseButtonDown, this);
        pauseButton.setFrames("btn_pause_on.png", "btn_pause_off.png", "btn_pause_on.png");
        pauseButton.scale.x = GameVars.scaleX;
        this.add(pauseButton);

        if (/Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent)) {
            this.createDpad();

            if (GameVars.gameData.dPadPosition === "left") {
                this.dPad.x = 80;
                this.jumpButton.x = GameConstants.GAME_WIDTH - 80;
                this.jumpText.x = GameConstants.GAME_WIDTH - 80;
            }
        }
    }

    public switchdPad(): void {

        if (this.dPad.x === 80) {
            this.dPad.x = GameConstants.GAME_WIDTH - 80;
            this.jumpButton.x = 80;
            this.jumpText.x = 80;
            GameManager.setDPad("right");
        } else {
            this.dPad.x = 80;
            this.jumpButton.x = GameConstants.GAME_WIDTH - 80;
            this.jumpText.x = GameConstants.GAME_WIDTH - 80;
            GameManager.setDPad("left");
        }
    }

    private createDpad(): void {

        this.dPad = new DPad(this.game);
        this.dPad.x = GameConstants.GAME_WIDTH - 80;
        this.dPad.y = GameConstants.GAME_HEIGHT - 80;
        this.add(this.dPad);

        this.jumpButton = new Phaser.Image(this.game, 80, GameConstants.GAME_HEIGHT - 80, "texture_atlas_1", "jump.png");
        this.jumpButton.anchor.set(.5);
        this.jumpButton.inputEnabled = true;
        this.jumpButton.alpha = .75;
        this.jumpButton.scale.set(1.25 * GameVars.scaleX, 1.25);
        this.jumpButton.events.onInputDown.add(this.jump, this);
        this.add(this.jumpButton);

        this.jumpText = new Phaser.Text(this.game, 80, GameConstants.GAME_HEIGHT - 78, "JUMP", {font: "18px RoundsBlack", fill: "#FFFFFF"});
        this.jumpText.scale.x = GameVars.scaleX;
        this.jumpText.anchor.set(.5);
        this.jumpText.alpha = .75;
        this.add(this.jumpText);
    }

    private jump(): void {
        
        RoadManager.jump();
    }

    private onPauseButtonDown(text: Phaser.Text): void {

        GameManager.showPauseLayer();
        text.scale.set(GameVars.scaleX, 1);
        text.fill = "#FFFFFF";
    }

    private onOverLabel(text: Phaser.Text): void {

        AudioManager.playSound("over");

        text.fill = "#FF3C45";
        text.scale.set(GameVars.scaleX * 1.05, 1.05);
    }

    private onOutLabel(text: Phaser.Text): void {

        text.scale.set(GameVars.scaleX, 1);
        text.fill = "#FFFFFF";
    }
}
